import app from '../../angular_app.es6';
import { waitingForDisableNextButton, waitingForEnableNextButton } from "../logic/react_interaction";

app.controller('FullPageController', [ '$scope', '$timeout', ($scope, $timeout) => {
  $scope.disableNavButtons = false;
  $scope.hideExamples = false;

  $scope.$on('disableNavButtons', () => {
    $scope.disableNavButtons = true;
  });
  $scope.$on('enableNavButtons', () => {
    $scope.disableNavButtons = false;
  });
  $scope.$on('hideExamples', () => {
    $scope.hideExamples = true;
  });
  $scope.$on('showExamples', () => {
    $scope.hideExamples = false;
  });

  waitingForEnableNextButton("Any", $timeout, () => {
    $scope.disableNavButtons = false;
  });
  waitingForDisableNextButton("Any", $timeout, () => {
    $scope.disableNavButtons = true;
  });
} ]);
